<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="4" class="fit-content">
                <v-text-field
                  label="Nama"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="fit-content">
                <v-text-field
                  label="Keterangan"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.keterangan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="1" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.actions="{ item }">
          <v-icon @click="deleteItem(item.id)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "KategoriLaporan",
  props: ["openModal"],
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        name: "",
        keterangan: "",
        kategori: "kategori_laporan"
      },
      dataHeaders: [
        { text: "Nama", value: "nama" },
        { text: "Keterangan", value: "keterangan" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.loading.fetchData = true;

      axios
        .get(`master-data?kategori=${this.formData.kategori}`)
        .then(res => {
          this.data = res.data;

          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;

          alert(err.response.data.message);
        });
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`master-data`, this.formData)
        .then(res => {
          this.loading.saveData = false;

          this.fetchData();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    async deleteItem(id) {
      if (confirm("Yakin Untuk Menghapus?")) {
        await axios
          .delete(`master-data/${id}`)
          .then(res => {
            this.fetchData();
          })
          .catch(err => {
            alert(err.response.data.message);
          });
      }
    },
    resetFormData() {
      this.formData.nama = "";
      this.formData.keterangan = "";
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
